import React, { useEffect, useState } from "react";
import { IParentSize } from "../../../../types";
import StrandComponent from "./strandComponent";
import { useRealtimeValues } from "../../../../system/websocketClient";
import { variables } from "./types";
import CastingFloor from "./castingFloor";
import SuperHeat from "./superHeat";
import RightPane from "./rightPane";

interface IProps {
  parentSize: IParentSize;
}

const Hmi = ({parentSize}: IProps) => {
  const [ realtimeDispatch, realtime ] = useRealtimeValues();
  const [retry, setRetry] = useState(0);

  useEffect(() => {

    realtimeDispatch({
      tags: variables,
      interval: 1000
    }, () => setRetry(prevState => (prevState + 1) % 100));
  }, [realtimeDispatch, retry, setRetry]);

  const width = (parentSize.width - 50) / 5;

  return (
    <div className="display-grid gap-1" style={{ ...parentSize, gridTemplateRows: "auto 1fr", overflowY: "auto" }}>
      <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
        <CastingFloor realtime={realtime}/>
        <SuperHeat realtime={realtime} parentSize={{ height: 300, width: (parentSize.width - 32) / 2 }}/>
        <RightPane realtime={realtime} />
      </div>
      <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }}>
        <StrandComponent title="Strand 1" realtime={realtime} strandCode="STR01" width={width}/>
        <StrandComponent title="Strand 2" realtime={realtime} strandCode="STR02" width={width}/>
        <StrandComponent title="Strand 3" realtime={realtime} strandCode="STR03" width={width}/>
        <StrandComponent title="Strand 4" realtime={realtime} strandCode="STR04" width={width}/>
        <StrandComponent title="Strand 5" realtime={realtime} strandCode="STR05" width={width}/>
      </div>
    </div>
  );
};

export default Hmi;
